import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default class AuthenticatedPslfDashboardIndexController extends Controller {
  @tracked v2 = '';

  queryParams = ['v2'];
}
